import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { useAuth, API } from "@/App";

// Contexte badges — un seul polling partagé par Sidebar + BottomNav
const BadgesContext = createContext({ communications: 0 });

export const BadgesProvider = ({ children }) => {
  const { token } = useAuth();
  const [badges, setBadges] = useState({ communications: 0 });

  useEffect(() => {
    if (!token) return;
    const headers = { Authorization: `Bearer ${token}` };
    let cancelled = false;
    const fetchCounts = async () => {
      try {
        const [sm, em] = await Promise.all([
          axios.get(`${API}/communications/sms-pending`, { headers }),
          axios.get(`${API}/communications/emails-pending`, { headers }),
        ]);
        if (cancelled) return;
        setBadges({ communications: (sm.data?.length || 0) + (em.data?.length || 0) });
      } catch { /* silent */ }
    };
    fetchCounts();
    const id = setInterval(fetchCounts, 60000);
    return () => { cancelled = true; clearInterval(id); };
  }, [token]);

  return <BadgesContext.Provider value={badges}>{children}</BadgesContext.Provider>;
};

export const useBadges = () => useContext(BadgesContext);
